import { PageUtils } from "./helpers/page-utils";

let videoLightBoxOpenButtons = document.querySelectorAll('.open-video-lightbox');

for (let openButton of videoLightBoxOpenButtons) {
    let parentPanel = openButton.closest('section');
    let lightbox = parentPanel.querySelector('.video-lightbox');
    let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
    let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);

    if (lightbox) {
        // Teleport to <body> so the lightbox escapes any parent z-index/transform
        // stacking context the surrounding panel may impose.
        if (lightbox.parentElement !== document.body) {
            document.body.appendChild(lightbox);
        }

        function closeLightBox() {
            lightbox.classList.add('opacity-0');
            lightbox.classList.add('pointer-events-none');
            PageUtils.bodyLockToggleOff();
            const lightboxHide = setTimeout(() => {
                lightbox.classList.add('hidden');
                clearTimeout(lightboxHide);
            }, 300);
        }

        function openLightBox() {
            lightbox.classList.remove('hidden');
            PageUtils.bodyLockToggleOn();
            const lightboxShow = setTimeout(() => {
                lightbox.classList.remove('opacity-0');
                lightbox.classList.remove('pointer-events-none');
                clearTimeout(lightboxShow);
            }, 50);
        }

        if (lightboxBackdrop) {
            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });
        }

        if (lightboxClose) {
            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });
        }

        document.addEventListener("keydown", (e) => {
            if (!lightbox.classList.contains('hidden')) {
                if (e.key === "Escape") {
                    closeLightBox();
                }
            }
        });

        openButton.addEventListener('click', () => {
            openLightBox();
        });
    }
}

